export default __webpack_public_path__ + "static/B0004-8e4ef23310eece66ef20a6c56d386571.png";